/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, ReactNode, FC } from 'react';
import { useTranslation } from 'react-i18next';
import useDarkMode from '../../hooks/useDarkMode';
import Icon from '../../components/icon/Icon';
import AuthContext from '../../contexts/authContext';

interface UserProps {
	collapsible: boolean;
	asideStatus: boolean;
	setAsideStatus(...args: unknown[]): unknown;
}

const User: FC<UserProps> = ({ collapsible, asideStatus, setAsideStatus }) => {
	const { logout } = useContext(AuthContext);

	const { darkModeStatus, setDarkModeStatus } = useDarkMode();

	const { t } = useTranslation(['translation', 'menu']);

	return (
		<nav aria-label='aside-bottom-user-menu-2'>
			<ul className='navigation'>
				<li className='navigation-item cursor-pointer mb-2'>
					<span
						className='navigation-link-info'
						onClick={() => setDarkModeStatus(!darkModeStatus)}
						role='button'>
						<span className='navigation-link navigation-link-pill'>
							<Icon
								icon={darkModeStatus ? 'LightMode' : 'DarkMode'}
								color={darkModeStatus ? 'info' : 'warning'}
								className='navigation-icon'
							/>
							<span className='navigation-text'>
								{darkModeStatus
									? (t('menu:LightMode') as ReactNode)
									: (t('menu:DarkMode') as ReactNode)}
							</span>
						</span>
					</span>
				</li>
				<li className='navigation-item cursor-pointer mb-2'>
					<span
						className='navigation-link-info navigation-link-pill'
						onClick={() => {
							if (logout) {
								logout();
							}
						}}
						role='button'>
						<span className='navigation-link'>
							<Icon icon='Logout' className='navigation-icon' />
							<span className='navigation-text'>Cerrar Sesión</span>
						</span>
					</span>
				</li>
				{/* <li className='navigation-item cursor-pointer mb-2'>
					<span
						className='navigation-link-info navigation-link-pill'
						onClick={() => setAsideStatus(!asideStatus)}
						role='button'>
						<span className='navigation-link'>
							<Icon
								icon='FirstPage'
								className='navigation-icon brand-aside-toggle-close'
							/>
							<Icon
								icon='LastPage'
								className='navigation-icon brand-aside-toggle-open'
							/>
							<span className='navigation-text'>
								{asideStatus ? 'Ocultar' : 'Fijar menu'}
							</span>
						</span>
					</span>
				</li> */}
			</ul>
		</nav>
	);
};

export default User;
